import { hashObject } from '@verdant-web/common';
export function getWipNamespace(namespace, schema) {
    return `@@wip-${namespace}-${hashObject(schema)}`;
}
//# sourceMappingURL=wip.js.map